import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        alias: '/login',
        name: 'home',
        component: Home
    },
    {
        path: '/app',
        name: 'app',
        component: () => import(/* webpackChunkName: "user" */ '../App.vue'),
        redirect: {name: 'user-dashboard'},
        children: [
            {
                path: 'dashboard',
                name: 'user-dashboard',
                component: () => import(/* webpackChunkName: "user" */ '../views/Dashboard.vue')
            }
        ]
    },
    {
        path: '/login/:secret',
        name: 'login',
        props: true,
        component: () => import(/* webpackChunkName: "org" */ '../views/Login.vue')
    },
    {
        // Legacy first-login setup page, removed; old links land on login
        path: '/onboard/:secret',
        redirect: {name: 'home'}
    },
    {
        path: '/accounts/:code',
        name: 'accounts',
        props: true,
        component: () => import(/* webpackChunkName: "org" */ '../views/Accounts.vue'),
        children: [
            {
                path: ':id',
                name: 'account',
                props: true,
                component: () => import(/* webpackChunkName: "user" */ '../views/Account.vue')
            }
        ]
    },
    {
        // Contact information: email, text-message phone, mailing address
        path: '/profile/:code',
        name: 'profile',
        props: true,
        component: () => import(/* webpackChunkName: "org" */ '../views/Profile.vue')
    },
    {
        path: '/messages/:code',
        name: 'messages',
        props: true,
        component: () => import(/* webpackChunkName: "org" */ '../views/Messages.vue'),
        children: [
            {
                path: ':id',
                name: 'message',
                props: true,
                component: () => import(/* webpackChunkName: "user" */ '../views/Message.vue')
            }
        ]
    },
    {
        path: '/approve_m/:code',
        name: 'approve_method',
        props: true,
        component: () => import(/* webpackChunkName: "org" */ '../views/ApproveMethod.vue')
    },
    {
        path: '/approve_p/:code',
        name: 'approve_payment',
        props: true,
        component: () => import(/* webpackChunkName: "org" */ '../views/ApprovePayment.vue')
    },
    {
        // Legacy agreement URL — redirect to new sign-agreement flow
        path: '/agreement/:hash',
        redirect: to => ({ path: `/sign-agreement/${to.params.hash}` })
    },
    {
        path: '/sign-agreement/:hash',
        name: 'sign_agreement',
        props: true,
        component: () => import(/* webpackChunkName: "org" */ '../views/SignAgreement.vue')
    },
    {
        path: '/sign-agreement/:hash/audit',
        name: 'sign_agreement_audit',
        props: true,
        component: () => import(/* webpackChunkName: "org" */ '../views/AgreementAudit.vue')
    },
    {
        path: '/id-upload/:token',
        name: 'id_upload',
        props: true,
        component: () => import(/* webpackChunkName: "org" */ '../views/IdUpload.vue')
    }
]

const router = new VueRouter({
    scrollBehavior: (to, from, savedPosition) => {
        if (savedPosition) {
            return savedPosition;
        } else if (to.hash) {
            return {
                selector: to.hash
            };
        } else {
            return { x: 0, y: 0 };
        }
    },
    base: process.env.BASE_URL,
    routes
})

export default router
